import { connect } from 'react-redux';

import { InfrastructureLayout, IInfrastructureLayoutStateProps } from '.';
import { IState } from '../../../store';
import { getInfrastructureElements } from '../../../utils/get_infrastructure_list';

export function mapStateToProps(state: IState): IInfrastructureLayoutStateProps {
  const { communicationSet, infrastructureList = [] } = state.villageData.village || {};

  return {
    infrastructureList: getInfrastructureElements(infrastructureList, communicationSet),
    isCroppedCard: state.isCroppedCard,
  };
}

export const InfrastructureLayoutContainer =
  connect<IInfrastructureLayoutStateProps>(mapStateToProps)(InfrastructureLayout);
